<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <v-dialog persistent v-model="dialog" width="800px" :fullscreen="$vuetify.breakpoint.xsOnly">
    <component :projectId="projectId" v-bind:is="currentViewComponent" v-on="handlers"></component>
    <v-card class="mt-2">
      <v-card-title class="py-6">
        <div class="test text-h6 text-sm-h4">
          {{ language.t("Projects.projects") }}
        </div>
        <v-spacer></v-spacer>
        <v-btn icon color="blue darken-1" @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col class="px-0 d-flex align-center px-2" :md="3" :sm="6" :cols="12">
              <v-btn block color="primary" small @click="newProject()" height="48">
                <v-icon>mdi-plus</v-icon>{{ language.t("Projects.newProject") }}
              </v-btn>
            </v-col>
            <v-col class="px-0 d-flex align-center px-2" :md="3" :sm="6" :cols="6">
              <v-btn block color="error" small @click="removeProject()" :disabled="!projectId" height="48">
                <v-icon>mdi-delete</v-icon>{{ language.t("Projects.removeProject") }}
              </v-btn>
            </v-col>
            <v-col class="px-0 d-flex align-center px-2" :md="3" :sm="6" :cols="6">
              <v-btn block color="accent" small @click="projectDetails()" :disabled="!projectId" height="48">
                <v-icon>mdi-lead-pencil</v-icon>{{ language.t("Projects.projectDetails") }}
              </v-btn>
            </v-col>
            <v-col class="pa-0 d-flex align-center px-2" :md="3" :sm="6" :cols="12">
              <v-text-field v-model="searchInput" class="pt-5 mr-2" solo
                :placeholder="language.t('Projects.searchProjects')" prepend-inner-icon="mdi-magnify">
              </v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <v-spacer></v-spacer>
        <div>
          <v-data-table :loading="loading" :headers="headers" :items="items" :items-per-page="5" single-select
            item-key="projectId" :search="searchInput" :custom-filter="searchProject" @click:row="selectProject"
            :footer-props="{
              itemsPerPageText: language.t('DataTables.itemsPerPageText'),
              itemsPerPageAllText: language.t('DataTables.itemsPerPageAllText'),
            }">
            <template v-slot:[`item.status`]="{ item }">
              <v-chip :color="getStatusColor(item.status)" dark>
                {{ item.status }}
              </v-chip>
            </template>

            <template v-slot:[`item.siteCalibration`]="{ item }">
              <span v-if="item.siteCalibration == null">
                <v-chip @click="addCalibrationFile(item)">
                  <v-icon>
                    mdi-plus
                  </v-icon>
                </v-chip>
              </span>
              <span v-else>
                {{ item.siteCalibration.name }}
              </span>

            </template>

            <template v-slot:[`footer.page-text`]="items">
              {{ items.pageStart }} - {{ items.pageStop }}
              {{ language.t("DataTables.pageText") }} {{ items.itemsLength }}
            </template>
          </v-data-table>
        </div>
      </v-card-text>
      <v-card-actions class="card-actions">
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="$emit('close')">
          <v-icon>mdi-close</v-icon>{{ language.t("App.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ProjectDetails from "./ProjectDetails";
import ProjectCreate from "./ProjectCreate";
import SiteCalibration from "./SiteCalibration";
import * as CONST from "../Constants.js";

export default {
  components: {
    ProjectDetails,
    ProjectCreate,
    SiteCalibration
  },
  props: {},
  data() {
    return {
      dialog: true,
      searchInput: "",
      currentViewComponent: null,
      loading: true,
      headers: [
        { text: this.language.t("Projects.projectName"), value: "name" },
        { text: this.language.t("Projects.projectStatus"), value: "status" },
      ],
      items: [],
      projectId: null,
      dialog: true,
      handlers: {
        close: this.closeComponent,
        update: this.updateProjects,
        save: this.saveProjString
      },
    };
  },
  mounted: function () {
    this.getProjects();
  },
  computed: {
    customerId() {
      return this.$auth.customerId;
    },
  },
  watch: {},
  methods: {
    saveProjString(projString, name, projectId) {
      this.$axios.post(route("api.projection.save"), { projString: projString, name: name, projectId: projectId }).then((res) => {
        this.$projections.addProjection(res.data);
        this.$emit("refreshProjections");
        this.currentViewComponent = null;
        this.updateProjects()
      });
    },
    addCalibrationFile(item) {
      console.log("TODO ADD CALIBRATION FILE");
      this.currentViewComponent = SiteCalibration;
    },
    updateProjects() {
      console.log("updateProjects");
      this.$emit("updateProjects");
      this.getProjects();
    },
    getStatusColor(status) {
      return status === this.language.t("Projects.ProjectStatusActive") ? "green" : "blue";
    },
    searchProject(value, search, item) {

      //TODO add search for site calibration name?
      if (!search){
        return true
      } 
      return item.name.toLowerCase().includes(search.toLowerCase())
      console.log(value)
      console.log(search)
      console.log(item)

    },
    getProjects() {
      var component = this;
      component.items = [];
      component.loading = true;
      this.headers = [
        { text: this.language.t("Projects.projectName"), value: "name" },
        { text: this.language.t("Projects.projectStatus"), value: "status" },
      ]
      if (this.$auth.subscription == "__SUB_CIVIL_ROADPLOTTER") {
        this.headers.push({ text: this.language.t("Projects.siteCalibration"), value: "siteCalibration" });
      }

      this.$axios.get(route("api.projects")).then((res) => {
        this.$projects.clearProjects()
        for (let i = 0; i < res.data.length; i++) {
          this.$projects.addProject(res.data[i])
          component.items.push({
            projectId: res.data[i].projectId,
            name: res.data[i].name,
            status: res.data[i].active === "1" ? this.language.t("Projects.ProjectStatusActive") : this.language.t("Projects.projectStatusDone"),
            siteCalibration: res.data[i].projection
          });
        }
        component.loading = false;
      });
    },
    selectProject(item, row) {
      let selectState = row.isSelected ? false : true;
      row.select(selectState);

      if (selectState) {
        this.projectId = item.projectId;
      } else {
        this.projectId = null;
      }
    },
    removeProject() {
      this.$axios
        .post(route("api.projects.remove", this.projectId))
        .then((res) => {
          console.log(res);
          this.success = true;
          this.projectId = null;
          this.getProjects();
        })
        .catch((error) => {
          this.saving = false;
          console.log(error.response.data);
          if (error.response.data.error) this.error = error.response.data.error;
          else this.error = "unknown server error";
        });
    },
    newProject() {
      console.log("Create project");
      this.currentViewComponent = ProjectCreate;
    },
    projectDetails() {
      console.log("Open projectdetails for project: " + this.projectId);
      this.currentViewComponent = ProjectDetails;
    },
    closeComponent() {
      this.currentViewComponent = null;
    },
    onClose() {
      this.$emit("close");
    },
  },
};
</script >
<style scoped>
.v-data-table >>> .v-data-table__selected {
  background: #8dbde4 !important;
}
</style>


